// Remover a importação do useEnvironmentStore
// import { useEnvironmentStore } from '@/stores/environment';

// Importar o store diretamente
import { environment } from '@/stores/environment';

export default {
  /**
   * Registra um erro de checkout junto com o payload original
   * @param {Object} payload - O payload que foi enviado para a API
   * @param {Error} error - O objeto de erro capturado
   * @param {String} endpoint - O endpoint que falhou (opcional)
   */
  async logCheckoutError(payload, error, endpoint = '/api/orderFinish') {
    try {
      // Usar a URL da API diretamente do ambiente ou um fallback
      //const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3003';
      const apiUrl = 'https://padraocolor.com.br';
      
      const errorLog = {
        timestamp: new Date().toISOString(),
        errorMessage: error.message || 'Erro desconhecido',
        errorStack: error.stack || '',
        originalPayload: this.sanitizePayload(payload),
        requestUrl: endpoint,
        userAgent: navigator.userAgent,
        url: window.location.href,
        userId: localStorage.getItem('userId') || sessionStorage.getItem('userId') || 'anonymous',
        errorType: this.categorizeError(error)
      };
      
      console.log('Registrando erro:', errorLog);
      
      const response = await fetch(`${apiUrl}/api/v2/errors`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          // Adicione headers de autenticação se necessário
          // 'Authorization': 'Bearer ' + localStorage.getItem('token')
        },
        body: JSON.stringify(errorLog)
      });
      
      if (!response.ok) {
        throw new Error(`Falha ao registrar erro: ${response.status}`);
      }
      
      console.log('Erro registrado com sucesso');
      return true;
    } catch (loggingError) {
      console.error('Falha ao registrar erro:', loggingError);
      this.storeErrorLocally(payload, error);
      return false;
    }
  },
  
  /**
   * Sanitiza o payload para remover dados sensíveis
   */
  sanitizePayload(payload) {
    // Clone o payload para não modificar o original
    const sanitized = JSON.parse(JSON.stringify(payload));
    
    // Sanitizar dados do cliente
    if (sanitized.customer) {
      // Mascarar CPF/CNPJ
      if (sanitized.customer.documentNumber) {
        const docLength = sanitized.customer.documentNumber.length;
        sanitized.customer.documentNumber = 'X'.repeat(Math.max(0, docLength - 4)) + 
          sanitized.customer.documentNumber.slice(-4);
      }
      
      // Mascarar telefone
      if (sanitized.customer.phone) {
        sanitized.customer.phone = 'XXXXXXX' + 
          (sanitized.customer.phone.slice(-4) || '');
      }
    }
    
    // Sanitizar dados de pagamento
    if (sanitized.payment) {
      // Cartão de crédito
      if (sanitized.payment.creditCard) {
        sanitized.payment.creditCard = {
          ...(sanitized.payment.creditCard || {}),
          number: sanitized.payment.creditCard.number ? 
            'XXXX-XXXX-XXXX-' + sanitized.payment.creditCard.number.slice(-4) : 'XXXX',
          cvv: 'XXX',
          expirationDate: 'XX/XX'
        };
      }
      
      // Outros métodos de pagamento sensíveis
      if (sanitized.payment.bankDetails) {
        sanitized.payment.bankDetails = {
          bank: sanitized.payment.bankDetails.bank,
          accountType: sanitized.payment.bankDetails.accountType,
          // Mascarar detalhes específicos da conta
          accountNumber: 'XXXXX'
        };
      }
    }
    
    return sanitized;
  },
  
  /**
   * Categoriza o erro com base na mensagem
   */
  categorizeError(error) {
    const message = (error.message || '').toLowerCase();
    
    if (message.includes('network') || message.includes('timeout') || message.includes('connection')) {
      return 'NETWORK_ERROR';
    } else if (message.includes('payment') || message.includes('pagamento') || message.includes('cartão')) {
      return 'PAYMENT_ERROR';
    } else if (message.includes('validation') || message.includes('validação') || message.includes('inválido')) {
      return 'VALIDATION_ERROR';
    } else if (message.includes('auth') || message.includes('unauthorized') || message.includes('token')) {
      return 'AUTH_ERROR';
    } else if (message.includes('not found') || message.includes('404')) {
      return 'NOT_FOUND_ERROR';
    }
    
    return 'GENERAL_ERROR';
  },
  
  /**
   * Armazena o erro localmente para tentar enviar mais tarde
   */
  storeErrorLocally(payload, error) {
    try {
      const errorLog = {
        timestamp: new Date().toISOString(),
        errorMessage: error.message || 'Erro desconhecido',
        payload: this.sanitizePayload(payload)
      };
      
      const storedErrors = JSON.parse(localStorage.getItem('pendingErrorLogs') || '[]');
      storedErrors.push(errorLog);
      
      // Limitar a 10 erros para não consumir muito espaço
      localStorage.setItem('pendingErrorLogs', JSON.stringify(storedErrors.slice(-10)));
    } catch (e) {
      console.error('Falha ao armazenar erro localmente:', e);
    }
  },
  
  /**
   * Tenta reenviar erros armazenados localmente
   */
  async syncPendingErrors() {
    try {
      const storedErrors = JSON.parse(localStorage.getItem('pendingErrorLogs') || '[]');
      if (storedErrors.length === 0) return;
      
      // Usar a URL da API diretamente do ambiente ou um fallback
      const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3003';
      
      // Tenta enviar cada erro pendente
      const results = await Promise.allSettled(
        storedErrors.map(errorLog => 
          fetch(`${apiUrl}/api/v2/errors`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(errorLog)
          })
        )
      );
      
      // Filtra os erros que não foram enviados com sucesso
      const failedErrors = storedErrors.filter((_, index) => 
        results[index].status !== 'fulfilled' || !results[index].value.ok
      );
      
      // Atualiza o localStorage apenas com os erros que falharam
      localStorage.setItem('pendingErrorLogs', JSON.stringify(failedErrors));
      
      console.log(`Sincronizados ${storedErrors.length - failedErrors.length} de ${storedErrors.length} erros pendentes`);
    } catch (e) {
      console.error('Falha ao sincronizar erros pendentes:', e);
    }
  }
}; 